import Vue from 'vue';
import VueMeta from 'vue-meta';
import Vuetify from 'vuetify/lib';
import { Plugin } from 'vue-fragment';
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import Xrange from 'highcharts/modules/xrange';
import highchartsMore from 'highcharts/highcharts-more';
import solidGauge from 'highcharts/modules/solid-gauge';
import sunburstInit from 'highcharts/modules/sunburst';
import patternFill from 'highcharts/modules/pattern-fill';
import LottieVuePlayer from '@lottiefiles/vue-lottie-player';
import VueIntercom from 'vue-intercom';
import { datadogRum } from '@datadog/browser-rum';
import 'vuetify/dist/vuetify.min.css';
import '@shared/assets/fonts/icons/customIcons.css';
import '@mdi/font/css/materialdesignicons.css';

import store from './store';
import router from './router';
import App from './App.vue';

Vue.config.productionTip = process.env.CURRENT_ENV === 'develop';
Vue.config.devtools = process.env.CURRENT_ENV !== 'production';

sunburstInit(Highcharts);
highchartsMore(Highcharts);
solidGauge(Highcharts);
Xrange(Highcharts);
patternFill(Highcharts);

Vue.use(VueMeta);
Vue.use(Vuetify);
Vue.use(HighchartsVue);
Vue.use(Plugin);
Vue.use(LottieVuePlayer);
Vue.use(VueIntercom, { appId: process.env.INTERCOM_APP_ID });
window.intercomSettings = {
  alignment: 'left',
};
datadogRum.init({
  applicationId: 'd10dfb91-8f5f-4cfe-9853-eef25fee6cbc',
  clientToken: 'pubdb7d8a2f1571af593d4e44c091b812f3',
  site: 'datadoghq.com',
  service: 'smartac.com-noc',
  env: process.env.CURRENT_ENV || 'develop',
  // Specify a version number to identify the deployed version of your application in Datadog
  // version: '1.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: 'mask-user-input',
});

datadogRum.startSessionReplayRecording();

async function initApp() {
  new Vue({
    router,
    store,
    render: (h) => h(App),
    vuetify: new Vuetify(),
  }).$mount('#app');
}

initApp();
